import { HttpContextToken } from '@angular/common/http';
import { v4 as newGuid } from 'uuid';
import { InjectionToken } from '@angular/core';

export interface ILoggerProvider {
  init(args: any): void;
}

export const LOGGING_PROVIDER = new InjectionToken<ILoggerProvider>(
  'Logging Provider Injection Token'
);

export const USE_CORRELATION_ID = new HttpContextToken(() => true);
export const CORRELATION_ID = new HttpContextToken(() => newGuid());
export const CORRELATION_HEADER = 'x-correlation-id';

export type LoggingContext = Partial<Record<LoggingContextProps, any>>;
export const LOGGING_CONTEXT = new HttpContextToken<LoggingContext | undefined>(
  () => undefined
);

export enum LoggingContextProps {
  Category = 'category',
  Method = 'method',
  Message = 'message',
  Context = 'context',
  ExtraProps = 'extraProps',
}

export enum LogContextKey {
  QuoteIdToken = 'quoteId',
  PolicyNumber = 'policyNumber',
}

//export
